import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCategories,
  setSelectedCategory,
} from "../store/slices/categorySlice";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import { updateSearchField } from "./../store/slices/searchSlice";

const MobileMegaMenu = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const { categories, status, error } = useSelector(
    (state) => state.categories
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false); // État du menu mobile
  const [openDropdown, setOpenDropdown] = useState(null); // Gérer le dropdown du niveau 2
  const [selectedCategory, setSelectedCategoryState] = useState(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (categoryId) => {
    setOpenDropdown(openDropdown === categoryId ? null : categoryId);
  };

  const handleCategorySelect = (category) => {
    dispatch(setSelectedCategory(category)); // Mise à jour du store avec la catégorie sélectionnée
    setSelectedCategoryState(category); // Mettre à jour l'état local
    setIsMenuOpen(false); // Fermeture du menu mobile après sélection
  };
  const handleCategorySet = (subCategory) => {
    // Mettre à jour la valeur de `query` avec le nom de la sous-catégorie
    dispatch(updateSearchField({ field: "query", value: subCategory.name }));

    // Mettre à jour la valeur de `categoryId` avec l'ID de la sous-catégorie
    dispatch(updateSearchField({ field: "categoryId", value: subCategory.id }));
    navigate("/resultats", { replace: true });
  };

  return (
    <div className="container-fluid">
      {/* Burger menu - Toggler */}
      <button
        className="navbar-toggler"
        type="button"
        onClick={toggleMenu}
        aria-controls="offcanvasNavbar"
        aria-expanded={isMenuOpen ? "true" : "false"}
        aria-label="Toggle navigation"
      >
        <img src="/menu-button.png" style={{position:"fixed",zIndex:99999999}} />
      </button>

      {/* Offcanvas menu */}
      <div
        className={`offcanvas w-100 h-100vh offcanvas-start ${isMenuOpen ? "show" : ""}`}
        tabIndex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
            <Link to="/">
              <img
                src="/images/twyLogo.svg"
                alt="Twyny Logo"
                className="logo-img"
              />
            </Link>
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            onClick={toggleMenu}
            aria-label="Close"
          ></button>
        </div>
        <div className="bodyHomeMenu offcanvas-body">
          {/* Accordéon pour gérer les catégories */}
          <div className="accordion" id="accordionMenu">
            {categories.map((category, index) => (
              <div key={category.id} className="accordion-item">
                <h2
                  className={`accordion-header ${
                    index === 0 ? "no-border" : ""
                  }`}
                  id={`heading-${category.id}`}
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${category.id}`}
                    aria-expanded="true"
                    aria-controls={`collapse-${category.id}`}
                    style={{
                      border: "none",
                      borderRadius: "0",
                      color: "rgba(32, 32, 32, 0.6588235294)",
                    }}
                  >
                    {category.name}
                  </button>
                </h2>
                <div
                  id={`collapse-${category.id}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`heading-${category.id}`}
                  data-bs-parent="#accordionMenu"
                >
                  <div className="accordion-body" style={{ padding: "0" }}>
                    {/* Sous-catégories */}
                    {category.children && category.children.length > 0 && (
                      <ul className="list-unstyled padd-list">
                        {category.children.map((subCategory) => (
                          <li key={subCategory.id} className="accordion-header">
                            <button
                              className={`accordion-button w-100 ${
                                openDropdown === subCategory.id
                                  ? ""
                                  : "collapsed"
                              }`}
                              type="button"
                              onClick={() => toggleDropdown(subCategory.id)}
                              style={{
                                border: "none",
                                borderRadius: "0",
                                color: "rgba(32, 32, 32, 0.6588235294)",
                                background: "transparent",
                                textAlign: "left",
                              }}
                            >
                              {subCategory.name}
                            </button>
                            {/* Sous-sous-catégories */}
                            {openDropdown === subCategory.id &&
                              subCategory.children &&
                              subCategory.children.length > 0 && (
                                <ul className="list-unstyled padd-list">
                                  {subCategory.children.map(
                                    (subSubCategory) => (
                                      <li
                                        key={subSubCategory.id}
                                        onClick={() =>
                                          handleCategorySet(subCategory)
                                        }
                                        className="accordion-header subCategorie-button"
                                      >
                                        {subSubCategory.name}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
            <div className="home-account">
              {isAuthenticated ? (
                <Link
                  to="/compte/informations-personnel"
                  className="user-profile-link"
                >
                  <img
                    src="/images/user-profile.svg"
                    alt="user-profile"
                    className="user-profile-img"
                  />
                  {user?.prenom} {user?.nom}
                </Link>
              ) : (
                <>
                  <Link
                    to="/registerPrestataire"
                    className="twyny-cta-list mr-8"
                  >
                    <button className=" twyny-cta-secondary">
                      Devenir partenaire
                    </button>
                  </Link>

                  <Link to="/login" className="twyny-cta-list ml-8">
                    <button className=" twyny-cta-primary  mt-8">
                      Se connecter
                    </button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMegaMenu;
